import { Disclosure, Menu, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import { SignInButton, UserButton, useAuth } from "@clerk/react";
import hotelLogo from "assets/images/hotelLogo.png";
import { useEffect, useState, type MouseEvent } from "react";
import { Link, useLocation } from "react-router-dom";
import ApiCall from "utils/ApiCall";
import { navItemsByHotel } from "../constants";
import AccountMenu from "./AccountMenu";

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export default function NavBar(props: any) {
  const location = useLocation();
  var { pathname } = location;
  const { hotel } = props;
  const { isLoaded, isSignedIn } = useAuth();

  const [navigation, setNavigation] = useState([
    // { name: 'Wait for room', href: '#', current: false },
    { name: "Room ready", href: "/room-ready", current: false },
    { name: "Pre-arrival", href: "/pre-arrival", current: true },
    { name: "Pre-auth", href: "/pre-auth", current: false },
    { name: "Payment", href: "/payment", current: false },
    { name: "Confirmation", href: "/confirmation", current: false },
    { name: "Remote Control", href: "/remote-control", current: false },
    // { name: 'Re-print slips', href: '#', current: false },
    // { name: 'Demo', href: '#', current: false },
  ]);
  const [hotelLogo, setHotelLogo] = useState();

  useEffect(() => {
    if (!localStorage.accessToken) {
      return;
    }
    const route = `${process.env.REACT_APP_API}/hotels/authed/logo`;
    ApiCall.get(route)
      .then((response) => {
        setHotelLogo(response.hotelLogo);
      })
      .catch((err) => {
        console.error("Failed to load hotel logo", err);
      });
  }, []);

  useEffect(() => {
    const hotelName = hotel?.getHotelName()?.toLowerCase()?.replace(/\s/g, "");
    const navItemsByHotelKey: string =
      Object.keys(navItemsByHotel).find((hotel) => {
        // console.log("??",hotelName.toLowerCase().replace(/\s/g, ""), hotel.toLowerCase())
        return hotelName
          .toLowerCase()
          .replace(/\s/g, "")
          .includes(hotel.toLowerCase());
      }) || "";

    // console.log("nav", navItemsByHotel[navItemsByHotelKey])
    if (!navItemsByHotel[navItemsByHotelKey])
      return setNavigation([
        { name: "Room ready", href: "/room-ready", current: false },
        { name: "Pre-arrival", href: "/pre-arrival", current: true },
      ]);

    var updatedNavigation: any[] = navigation
      .filter((item) =>
        navItemsByHotel[navItemsByHotelKey].find(
          (navName) => navName === item.name
        )
      )
      .map((item) => ({
        ...item,
        current: item.href === pathname,
      }));

    if (!updatedNavigation.find((item) => item.current)) {
      updatedNavigation[0].current = true;
    }

    setNavigation(updatedNavigation);
  }, []);

  const handleNavItemClick: Function = (item: any) => {
    const index = navigation.findIndex((nav) => nav.name === item.name);
    const allNotAcitive = navigation.map((nav) => ({ ...nav, current: false }));
    allNotAcitive.splice(index, 1, { ...allNotAcitive[index], current: true });
    setNavigation([...allNotAcitive]);
  };

  return (
    <Disclosure as="nav" className="bg-slate-900">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start h-16">
                <div className="flex-shrink-0 flex items-center h-16">
                  <div className="text-slate-100">
                    {props.hotel.hotelName === "Mini Hotel"
                      ? "CWB"
                      : props.hotel.hotelName === "Mini Central"
                      ? "CTL"
                      : ""}
                  </div>
                  <img
                    className="block lg:hidden object-scale-down h-full"
                    // src="https://tailwindui.com/img/logos/workflow-mark.svg?color=indigo&shade=500"
                    src={hotelLogo}
                    alt="hotel logo"
                  />
                  <img
                    className="hidden lg:block object-scale-down h-full"
                    src={hotelLogo}
                    alt="hotel logo"
                  />
                </div>
                <div className="hidden sm:block sm:ml-6 my-auto">
                  <div className="flex space-x-4">
                    {navigation.map((item: any) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        onClick={() => handleNavItemClick(item)}
                      >
                        <div
                          className={classNames(
                            item.current
                              ? "bg-slate-200 text-black"
                              : "text-slate-100 hover:bg-slate-200 hover:text-black",
                            "px-3 py-2 rounded-md text-sm font-medium"
                          )}
                          aria-current={item.current ? "page" : undefined}
                        >
                          {item.name}
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <div className="absolute inset-y-0 left-0 flex items-center gap-2 pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {isLoaded && !isSignedIn && (
                  <SignInButton
                    mode="modal"
                    withSignUp={false}
                    appearance={{
                      elements: {
                        footerAction: { display: "none" },
                      },
                    }}
                  >
                    <button
                      type="button"
                      className={classNames(
                        "bg-yellow-600 text-white hover:bg-yellow-700",
                        "px-3 py-2 rounded-md text-sm font-medium"
                      )}
                    >
                      Sign in
                    </button>
                  </SignInButton>
                )}
                {isLoaded && isSignedIn && (
                  <AccountMenu
                    style={{ cursor: "pointer" }}
                    onClick={(e: MouseEvent<HTMLDivElement>) => {
                      const target = e.target as HTMLElement;
                      // Prevent triggering again if they already clicked the Avatar button itself
                      if (target.closest(".cl-userButtonTrigger")) return;

                      const btn = e.currentTarget.querySelector(
                        ".cl-userButtonTrigger"
                      ) as HTMLButtonElement;
                      if (btn) btn.click();
                    }}
                  >
                    <div
                      style={{
                        marginRight: "15px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <UserButton
                        afterSignOutUrl="/login"
                        appearance={{
                          elements: {
                            userButtonAvatarBox: {
                              width: "24px",
                              height: "24px",
                            },
                            userButtonPopoverActionButton__manageAccount: {
                              display: "none",
                            },
                            userButtonPopoverActionButtonIconBox__manageAccount:
                              {
                                display: "none",
                              },
                          },
                        }}
                      />
                    </div>
                    Account
                  </AccountMenu>
                )}
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-slate-200 text-black"
                      : "text-slate-100 hover:bg-slate-200 hover:text-black",
                    "block px-3 py-2 rounded-md text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
